import { environment } from 'src/environments/environment';
import { UtilsService } from '../_services/utils.service';
import * as i0 from "@angular/core";
import * as i1 from "../_services/utils.service";
var CardPaymentService = /** @class */ (function () {
    function CardPaymentService(_utilsService) {
        this._utilsService = _utilsService;
    }
    CardPaymentService.prototype.addFunds = function (user_id, is_welcome) {
        if (is_welcome === void 0) { is_welcome = 0; }
        var url = "" + environment.phpApiUrl + '/cashier/add-funds/' + ("" + environment.DRAFT_ACCESS_TOKEN) + '/' + user_id;
        if (is_welcome)
            url = url + "?is_welcome=" + is_welcome;
        return this._utilsService.getRequest(url);
    };
    CardPaymentService.prototype.checkPromoCode = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/cashier/check-promo-code', data, null, 'content-type-json');
    };
    CardPaymentService.prototype.checkPromoCodeByAmt = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/promocode/check', data, null, 'content-type-json');
    };
    CardPaymentService.prototype.ftpCard = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/cashier/add-new-funds', data, null, 'content-type-json');
    };
    CardPaymentService.prototype.saveCardPayment = function (data) {
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/cashier/add-amount', data, null, 'content-type-json');
    };
    CardPaymentService.ngInjectableDef = i0.defineInjectable({ factory: function CardPaymentService_Factory() { return new CardPaymentService(i0.inject(i1.UtilsService)); }, token: CardPaymentService, providedIn: "root" });
    return CardPaymentService;
}());
export { CardPaymentService };
